import { render, staticRenderFns } from "./AccordionCareComposition.vue?vue&type=template&id=558304bb&"
import script from "./AccordionCareComposition.vue?vue&type=script&lang=js&"
export * from "./AccordionCareComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports